/** @jsx jsx */

import React, {
  Fragment as _,
  memo,
  useMemo,
  useCallback,
  useContext,
  useRef,
  useState,
  useEffect,
  useLayoutEffect,
  FC,
} from 'react';
import { createPortal } from 'react-dom';
import { Box } from 'theme-ui';
import { keyframes } from 'emotion';
import { css, jsx } from '@emotion/core';
import { useSelector, useDispatch, connect } from 'react-redux';
import { colors } from 'styles/variables';
import { EditWrapper0, EditWrapper1 } from './EditWrappers';
import LoadingSpinner from 'components/UI/LoadingSpinner';
import FullScreenIcon from 'assets/FullScreenIcon.svg';
import isAndroidSamsung from 'services/isAndroidSamsung';
import isiOS from 'services/isiOS';
import CloseFullscreenEmbed from 'assets/CloseFullscreenEmbed.svg';
import { hideHeaderAction } from 'actions/hideHeaderAction';
import PDFIcon from 'assets/PDF.svg';
import PDFHero from 'assets/PDF_HERO.svg';

// const OpenPDF: FC<{
//   src: string;
//   pdfSrc: string;
// }> =

const OpenPDF = ({
  id,
  mediaParentId,
  selected,
  src: imgSrc,
  pdfSrc,
  children,
  cardColor,
  cardOutline,
  includeImage,
  includeText,
  includeShadow,
}) => {
  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItesm: 'center',
        width: '100%',
        height: '100%',
        fontSize: '14px',
        fontWeight: 500,
        cursor: window.dev && !window.dev() ? 'pointer' : 'auto',
        //
        background: cardColor,
        border: `1px solid ${cardOutline}`,
        ...(includeShadow &&
          {
            // boxShadow: '0px 0px 11.7411px rgba(13, 16, 40, 0.15)',
          }),

        borderRadius: '25px',
      }}
      onClick={() => {
        if (window.dev && window.dev()) {
          return;
        }

        if (!pdfSrc) {
          alert(
            'Oops! No file has been specified. Check the source in your pdf settings.'
          );
          return;
        }

        window.open(pdfSrc);
      }}
    >
      {window.dev && window.dev() ? (
        <EditWrapper0 id={id} mediaParentId={mediaParentId} selected={selected}>
          <img
            src={imgSrc}
            style={{
              width: '100%',
              // maxWidth: 'calc(50vh)',
              // outline: '1px solid blue',
            }}
            // onClick={() => {
            //   if (window.dev && window.dev()) {
            //     return;
            //   }

            //   window.open(pdfSrc);
            // }}
          />
        </EditWrapper0>
      ) : (
        <img
          src={imgSrc}
          style={{
            width: '100%',
            // maxWidth: 'calc(50vh)',
            // outline: '1px solid blue',
          }}
          // onClick={() => {
          //   if (window.dev && window.dev()) {
          //     return;
          //   }

          //   window.open(pdfSrc);
          // }}
        />
      )}

      {/* {children} */}
      {includeText && (
        <Box
          sx={{
            position: 'relative',
            marginTop: window.dev && window.dev() ? '10px' : '20px',
            textAlign: 'center',
            // padding: '10px',
            // zIndex: 2147483647,

            // ':hover': {
            //   opacity: 0.8,
            //   transition: 'opacity 0.2s',
            // },
            // color: '#060709',
            fontWeight: 300,
          }}
        >
          {children}
        </Box>
      )}
    </Box>
  );
};

export { OpenPDF };
